var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.666,
    height: 19.666,
    viewBox: "0 0 19.666 19.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-money-5633622",
    d: "M72.3,63.688H67.38l-1.822-2.731A.612.612,0,0,1,66.069,60H73.6a.612.612,0,0,1,.511.957ZM67.38,64.916H72.3l.5.323c2.185,1.394,6.874,4.4,6.874,10.738a3.688,3.688,0,0,1-3.688,3.688H63.691A3.688,3.688,0,0,1,60,75.977c0-6.341,4.7-9.343,6.874-10.738Zm3.225,3.378h0a.769.769,0,1,0-1.538,0v.538a2.991,2.991,0,0,0-.852.328,1.923,1.923,0,0,0-1,1.687,1.8,1.8,0,0,0,.948,1.565,6.077,6.077,0,0,0,1.368.538H69.6a4.864,4.864,0,0,1,1.075.411c.2.122.223.21.227.315a.437.437,0,0,1-.227.406,1.517,1.517,0,0,1-.822.179,4.764,4.764,0,0,1-1.324-.31l-.28-.092a.769.769,0,0,0-.485,1.455c.074.022.153.052.232.083a9.222,9.222,0,0,0,1.084.319v.573a.769.769,0,1,0,1.538,0v-.533a2.718,2.718,0,0,0,.874-.345,1.957,1.957,0,0,0,.97-1.726,1.879,1.879,0,0,0-.944-1.6,6.157,6.157,0,0,0-1.429-.577h-.026a5.138,5.138,0,0,1-1.1-.411c-.2-.118-.205-.188-.205-.258a.376.376,0,0,1,.24-.354,1.608,1.608,0,0,1,.839-.192,4.782,4.782,0,0,1,1.2.2A.769.769,0,0,0,71.431,69c-.249-.066-.524-.131-.808-.179v-.529Z",
    transform: "translate(-60.003 -60)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.821e7ae2e0dd316195a61540408490de.svg";
export { ForwardRef as ReactComponent };